import {Component} from "../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-black-image.scss";

export class WebsiteBlackImageComponent extends Component {
    constructor(image: string, alt: string) {
        super();

        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackImage}">
                <div class="${s.image}">
                    <img class="${s.screen}" src="${image}"
                         alt="${alt}"/>
                </div>
            </div>
        `;
    }
}